module.exports = __webpack_public_path__ + "img/blog1.d85bb42d.jpg";